import { Dialog, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import { IconArrowRight } from '@tabler/icons-react';

interface TourGuideInitialModalProps {
  showTourModal: boolean;
  startTour: () => void;
  skipTour: () => void;
}

function TourGuideInitialModal(props: TourGuideInitialModalProps) {
  const { showTourModal, startTour, skipTour } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog open={showTourModal} fullScreen={fullScreen}>
      <DialogContent>
        <Typography
          variant="body1"
          width="360px"
          align="center"
          fontSize="18px"
          fontWeight={500}
        >
          Would you like a guided tour to learn how to create a demand letter?
        </Typography>
      </DialogContent>
      <DialogActions>
        <DialogActions>
          <Box
            paddingX={3}
            display="flex"
            justifyContent="space-between"
            gap={2}
          >
            <Button variant="text" onClick={skipTour}>
              No, Skip Tour
            </Button>
            <Button
              variant="contained"
              onClick={startTour}
              endIcon={<IconArrowRight />}
            >
              Yes, Start Tour
            </Button>
          </Box>
        </DialogActions>
      </DialogActions>
    </Dialog>
  );
}

export default TourGuideInitialModal;
